import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Modal from 'components/common/modal-component';
import { ModalButton } from 'models/utils/common/modal-button-model';

export const STATEMENT_RECENT_UPDATES_ID_BLOCK = 'statement-recent-update-id';
export const STATEMENT_RECENT_UPDATES_BLOCK = 'statement-recent-updates';

const RecentStatementUpdatesModal = ({ onClose, onSave }) => {
  const primaryButton = useMemo(
    () =>
      new ModalButton({
        text: 'recent-updates-information-modal.button',
        onClick: () => onSave(),
      }),
    [onSave],
  );

  const secondaryButton = useMemo(
    () =>
      new ModalButton({
        text: 'common.close',
        onClick: () => onClose(),
      }),
    [onClose],
  );

  const formattedMessageValues = useMemo(
    () => ({
      ol: (chunks) => (
        <ol className={`${STATEMENT_RECENT_UPDATES_BLOCK}`}>{chunks}</ol>
      ),
      li: (chunks) => <li>{chunks}</li>,
      b: (chunks) => <b>{chunks}</b>,
      br: <br />,
    }),
    [],
  );

  return (
    <Modal
      id={STATEMENT_RECENT_UPDATES_ID_BLOCK}
      onClose={onClose}
      title={'statement-recent-updates-information-modal.title'}
      className={`${STATEMENT_RECENT_UPDATES_BLOCK}__modal`}
      primaryModalButton={primaryButton}
      secondaryModalButton={secondaryButton}
    >
      <div className={`${STATEMENT_RECENT_UPDATES_BLOCK}__container`}>
        <div
          className={`${STATEMENT_RECENT_UPDATES_BLOCK}__recent-updates-message`}
        >
          <FormattedMessage
            id={'statement-recent-updates-information-modal.message'}
            values={formattedMessageValues}
          />
        </div>
      </div>
    </Modal>
  );
};

RecentStatementUpdatesModal.propTypes = {
  /** Modal panel onClose function  */
  onClose: PropTypes.func.isRequired,
  /** Modal panel onSave function  */
  onSave: PropTypes.func.isRequired,
};

export default RecentStatementUpdatesModal;
